<template>
  <div class="characteristics">
    <table class="table table-striped">
      <tr>
        <th>{{ trans('core.time') }}</th>
        <th>{{ trans('core.employee') }}</th>
        <th>{{ trans('studyplan.approved') }}</th>
      </tr>
      <tr v-if="Object.keys(studentCharacteristics).length === 0">
        <td
          colspan="3"
        >
          {{ trans('studyplan.no_approval_history') }}
        </td>
      </tr>
      <template v-else>
        <tr
          v-for="studentCharacteristic in studentCharacteristics"
        >
          <td>{{ studentCharacteristic.start }}</td>
          <td>{{ studentCharacteristic.user == null ? trans('subscription.subscribable_system_change') : users[studentCharacteristic.user].name }}</td>
          <td>
            <span
              v-if="studentCharacteristic.value === '1'"
              class="fa fa-check"
            />
            <span
              v-else
              class="fa fa-remove"
            />
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ApprovalHistory',
  props: {
    studentCharacteristics: {
      required: true,
      type: Object,
    },
    users: {
      required: true,
      type: Object,
    },
  },
}
</script>

<style scoped lang="scss">

</style>
